import React from 'react';
import './AboutUs.css';
import logo from '../assets/logo.png';
import heroImg from '../assets/about/hero.jpg';
import chairmanImg from '../assets/about/founder.jpg';
import schoolImg from '../assets/about/school.jpg';
import MainMenu from '../components/MainMenu';
import directorImg from '../assets/about/director.jpg';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="about-page">
      
  <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

      {/* Hero Section */}
      <section className="about-hero">
        <img src={heroImg} alt="Universal Academy Campus" />
        <div className="hero-text">
          <h1>ABOUT US</h1>
		   <p>Discover a vibrant campus filled with passion, purpose, and personal growth.</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="about-intro">
        <h2>Every School Has a Story... Welcome to Ours!</h2>
        <p>
          Universal Academy School, Affiliated to CBSE, nestled in the beautiful town of Karaikal, is an institution for students of all faiths. At Universal, we create a bright future for our children. A venture of Universal Foundation, founded in 2013, the journey of the school has been one of vision and excellence in academics, sports, and extracurriculars.
        </p>
      </section>

      {/* Leadership Section */}
      
	  
	  <section className="about-leaders">

        {/* 1 - Chairman */}
        <div className="leader-row">
          <div className="leader-image">
            <img src={chairmanImg} alt="Chairman" />
          </div>
          <div className="leader-text">
            <h3>OUR CHAIRMAN</h3>
            <h2>Mr. C. Mahendran</h2>
            <p className="subtitle">Fostering Unparalleled Academic Excellence!!</p>
            <p>To liberate from darkness and to empower minds has been the greatest vision of our school.</p>
          </div>
        </div>

        {/* 2 - Correspondent */}
        <div className="leader-row reverse">
          <div className="leader-image">
            <img src={chairmanImg} alt="Correspondent" />
          </div>
          <div className="leader-text">
            <h3>OUR CORRESPONDENT</h3>
            <h2>Mrs. M. Anandhi</h2>
            <p className="subtitle">Creating Brighter Future for our Children!!</p>
            <p>The task of bringing up and training children to face all walks of their lives is one of the most important concerns of our school.</p>
          </div>
        </div>

        {/* 3 - Director */}
        <div className="leader-row">
          <div className="leader-image">
            <img src={directorImg} alt="Director" />
          </div>
          <div className="leader-text">
            <h3>OUR DIRECTOR</h3>
            <h2>Er. M. Ashwin Kumar</h2>
            <p className="subtitle">Educational Excellence for Social Change</p>
            <p>
              Our core aspiration is to provide an Educational Excellence through which every student makes a positive difference to the society. At Universal, we ensure children enjoy school in a safe and secure atmosphere designed to fulfill their potential.
            </p>
          </div>
        </div>

      </section>

      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default AboutUs;
